module.exports = __webpack_public_path__ + "img/luxembourg-flag.a099aba.png";